// components/BreadcrumbsWrapper.jsx
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function BreadcrumbsWrapper({ items = [] }) {
  const navigate = useNavigate();

  return (
    <Breadcrumbs aria-label="breadcrumb" className="mb-2" separator="›">
      {items.map((item, index) =>
        item.path ? (
          <Link
            key={index}
            underline="hover"
            color="inherit"
            onClick={() => navigate(item.path)}
            sx={{ cursor: 'pointer' }}
          >
            {item.label}
          </Link>
        ) : (
          <Typography key={index} color="text.primary">
            {item.label}
          </Typography>
        )
      )}
    </Breadcrumbs>
  );
}
